import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';


const PrivacyPolicy = () => {
    const [htmlContent, setHtmlContent] = useState('');
    const [fileName, setFileName] = useState(null);
    const [brandName, setBrandName] = useState('');

    const location = useLocation();

    useEffect(() => {
        const path = location.pathname.split("/");
        console.log("privacy-policy-path", path)
        if (path.length >= 2 && path[1] === "privacy-policy" && path[2]) {
            setFileName(path[2])
        }
        const params = new URLSearchParams(location.search);
        const brand = params.get('brand');
        if (brand) setBrandName(brand);
    }, []);

    useEffect(() => {

        if (fileName && fileName.length > 0) {
            console.log("file name: ", fileName)
            const importHTML = async () => {
                try {
                    const htmlModule = await import(`../../../assests/privacyPolicyPages/${fileName}.json`);
                    setHtmlContent(htmlModule.htmlContent);
                } catch (error) {
                    console.error('Error fetching HTML, loading default:', error);
                    try {
                        const defaultModule = await import(`../../../assests/privacyPolicyPages/default.json`);
                        const name = brandName || fileName;
                        setHtmlContent(defaultModule.htmlContent.replaceAll('{{BRAND_NAME}}', name));
                    } catch (defaultError) {
                        setHtmlContent(null);
                        console.error('Error fetching default HTML:', defaultError);
                    }
                }
            };

            importHTML();
        }
    }, [fileName, brandName]);

    // console.log("htmlContent", htmlContent);

    return (

        <div className="bglog">
            {
                htmlContent ? htmlContent.length > 0 &&
                <section className="data-deletion ">
                    <div
                        dangerouslySetInnerHTML={{ __html: htmlContent }}
                    />
                </section>

                : 

                <h2 className='text-lg font-semibold'> Invalid Url </h2>
            }
        </div>
    );
};

export default PrivacyPolicy;